import { render, staticRenderFns } from "./AddPeopleModal.vue?vue&type=template&id=0a4f1674&"
import script from "./AddPeopleModal.vue?vue&type=script&lang=js&"
export * from "./AddPeopleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports